<template>
  <v-card flat class="auth-accountant--header" color="transparent">
    <v-row align="center">
      <v-col cols="12">
        <v-toolbar flat color="grey lighten-2" class="px-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small fab text color="secondary" v-on="on" :loading="isLoading" @click="reset">
                <v-icon small>fal fa-redo</v-icon>
              </v-btn>
            </template>
            <span>リセットする</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small fab text v-on="on" :disabled="isLoading" @click="search">
                <v-icon small>fal fa-search</v-icon>
              </v-btn>
            </template>
            <span>検索する</span>
          </v-tooltip>
          <v-menu
            v-model="config.datepicker"
            :close-on-content-click="false"
            max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field solo flat hide-details
                v-on="on"
                v-model="printFormattedDates"
                placeholder="引出日"
                clear-icon="fal fa-times"
                background-color="transparent"
                :append-icon="form.date.length ? 'fal fa-times' : null"
                @click:append="form.date = []"
              />
            </template>
            <v-date-picker range no-title
              v-model="form.date"
            />
          </v-menu>
          <v-menu bottom right offset-y
            :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn fab text small
                v-on="on"
                class="mr-2"><v-icon small>fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-select v-model="form.area"
                      label="支店"
                      :items="getAreaItems"
                      @change="search(1)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed
                  color="secondary"
                  @click="search">検索する</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-btn-toggle v-if="$vuetify.breakpoint.smAndUp" mandatory class="grey lighten-3" v-model="form.status" @change="search(1)">
            <v-btn :text="form.status !== 'process'" :depressed="form.status === 'process'" color="secondary white--text" :value="'process'">未完</v-btn>
            <v-btn :text="form.status !== 'done'" :depressed="form.status === 'done'" color="secondary white--text" :value="'done'">完了</v-btn>
            <v-btn :text="form.status !== 'unprocess'" :depressed="form.status === 'unprocess'" color="secondary white--text" :value="'unprocess'">不要</v-btn>
          </v-btn-toggle>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row dense align="center" class="mt-2">
      <v-col cols="12" sm="3" md="2" class="fm-in">
        <p class="caption grey--text text--darken-2">表示数</p>
        <v-btn-toggle mandatory dense class="transparent" v-model="form.limit" @change="search(1)">
          <v-btn :text="form.limit !== '20'" :depressed="form.limit === '20'" color="secondary white--text" value="20">20</v-btn>
          <v-btn :text="form.limit !== '50'" :depressed="form.limit === '50'" color="secondary white--text" value="50">50</v-btn>
          <v-btn :text="form.limit !== '100'" :depressed="form.limit === '100'" color="secondary white--text" value="100">100</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="!isLoading" cols="4" sm="2" class="py-2">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{ printPageInfo }}</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="searchFirstPage">
              <v-list-item-title class="caption text-center">最初</v-list-item-title>
            </v-list-item>
            <v-list-item @click="searchLastPage">
              <v-list-item-title class="caption text-center">最後</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
      <v-col cols="2" sm="1" md="1" lg="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
              v-on="on"
              color="secondary"
              :disabled="isLoading || !isAccessiblePrev"
              @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" sm="1" md="1" lg="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
              v-on="on"
              color="secondary"
              :disabled="isLoading || !isAccessibleNext"
              @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
  </v-card>
</template>

<script>
const DEF = {
  FORM: {
    status: 'process',
    limit: '20',
    page: 1,
    size: 0,
    area: '',
    date: []
  },
}
export default {
  name: 'authorAccountantToolbars',
  props: [
    'status'
  ],
  data () {
    return {
      config: {
        datepicker: false
      },
      meta: {
        status: [
          { value: 'process', text: '振分未完' },
          { value: 'done', text: '振分完了' },
          { value: 'unprocess', text: '振分不要' }
        ]
      },
      form: {
        status: DEF.FORM.status,
        limit: DEF.FORM.limit,
        page: DEF.FORM.page,
        size: DEF.FORM.size,
        area: DEF.FORM.area,
        date: DEF.FORM.date
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.search()
    },
    reset: function () {
      this.$set(this, 'form', JSON.parse(JSON.stringify(DEF.FORM)))
      this.search(1)
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$nextTick(() => {
          let fm = this.getForm(page)
          this.$emit('emit', {
            action: 'get',
            data: fm
          })
        })
      }
    },
    searchFirstPage: function () {
      this.$set(this.form, 'page', 1)
      this.search(1)
    },
    searchLastPage: function () {
      const { limit, size } = this.form
      const last = Math.floor(size / limit) + ((size % limit) > 0 ? 1 : 0)
      this.$set(this.form, 'page', last)
      this.search(last)
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.search(num - 1)
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.search(num + 1)
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    getForm: function (page) {
      return {
        status: this.form.status,
        area: this.form.area,
        date: this.form.date,
        limit: {
          offset: (page != null && Number.isFinite(page)) ? page : this.form.page,
          size: parseInt(this.form.limit)
        },
        page: (page != null && Number.isFinite(page)) ? page : this.form.page
      }
    },
    clearDate: function () {
      this.$set(this.form, 'date', '')
      this.search(1)
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    printFormattedDates () {
      const [ dateA, dateB ] = this.form.date
      if (this.form.date.length === 2) {
        if (this.$moment(dateA).isBefore(dateB)) {
          return `引出日：${this.$moment(dateA).format('YYYY/MM/DD')} ~ ${this.$moment(dateB).format('YYYY/MM/DD')}`
        } else {
          return `引出日：${this.$moment(dateB).format('YYYY/MM/DD')} ~ ${this.$moment(dateA).format('YYYY/MM/DD')}`
        }
      } else if (this.form.date.length === 1) {
          return `引出日：${this.$moment(dateA).format('YYYY/MM/DD')}`
      } else {
        return ''
      }
    },
    getAreaItems () {
      return [{
        value: '',
        text: '全店'
      }, ...Object.keys(this.$mango.areas).map(key => {
        return {
          value: key,
          text: this.$mango.areas[key]
        }
      })]
    },
    getStatusItems () {
      return this.meta.status
    },
    printDateFormat () {
      return this.form.date ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return this.form.size ? `${st} - ${ed} / ${this.form.size}` : ``
    }
  }
}
</script>

<style lang="scss">
.auth-accountant--header {
  .fm-in {
    position: relative;
    .caption {
      position: absolute;
      top: -1.2em;
    }
  }
}
</style>
